import { Box, Flex, Text } from '@chakra-ui/layout'
import { Switch } from '../../components/Switch'
import { Input } from '@chakra-ui/input'
import { Button } from './components/Button'
import { OptionButton } from './components/InputInnovationSelect/Options'
import { InputInnovationSelect } from './components/InputInnovationSelect'
import { useEffect, useState } from 'react'
import { FaCheckCircle } from 'react-icons/fa'
import { Date as DateComponent } from '../../components/Date'
import { useValorVerba } from '../../hooks/useValorVerba'
import { Icon } from '@chakra-ui/icon'
import { useMediaQuery } from '@chakra-ui/react'
import { ModalCliente } from './components/ModalCliente'
import { useFunilVendas } from '../../hooks/useFunilVendas'
import { DropdownCheckbox } from './components/DropdownCheckbox'
import { format } from 'date-fns'
import { formatPrice } from '../../utils/formatPrice'
import { useMutation } from 'react-query'
import { useParams, useSearchParams } from 'react-router-dom'
import { api } from '../../services/api'
import { useForm } from 'react-hook-form'
import { infoColor } from '../../utils/infoColorFunil'

async function getPropostasAcompanhamento({ params, userCode }) {
  const response = await api.get(`/chamado/listar-pedidos-vendedores`, {
    params: {
      codigo_consultor: userCode,
      ...params,
    },
  })

  return (
    response.data.data.data
      .map((item) => {
        return {
          ...item,
          info_contato: item.info_contato.map((item) => {
            return {
              celular_parceiro: item.celular_contato?.trim(),
              telefone_parceiro: item.telefone_contato?.trim(),
              email_contato: item.email_contato?.trim(),
              nome_cliente: item.nome_contato?.trim(),
            }
          }),
          data_controle: item.data_controle ? format(new Date(item.data_controle), 'dd/MM/yyyy') : '',
          ultimo_contato: item.ultimo_contato ? format(new Date(item.ultimo_contato), 'dd/MM/yyyy HH:mm') : '',
          link_proposta: `${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-pdf-sankhya/${item.nunota}`,
          abertura: item.data_abertura ? format(new Date(item.data_abertura), 'dd/MM/yyyy HH:mm') : '',
          lineColor: infoColor[item.funil_vendas],
          data_funil: item.data_status ? format(new Date(item.data_status), 'dd/MM/yyyy HH:mm') : '',
          abertura_order: item.data_abertura,
          retornar_em_order: item.retorno_cliente,
          proposta: item.codigo_proposta,
          desconto: item.desconto ? item.desconto : '',
          desconto_order: item.desconto === 'S' ? 1 : 0,
          cliente: item.nome_cliente?.toLowerCase() || '',
          verba: item.verba ? item.verba : '',
          propostaEncaminhada: item.data_proposta_encaminhada,
          layoutEnviado: item.data_encaminhamento_layout ? format(new Date(item.data_encaminhamento_layout), 'dd/MM/yyyy HH:mm') : '',
          funilVendas: item.funil_vendas?.toLowerCase() || '',
          ultimoContato: item.data_perda ? format(new Date(item.data_perda), 'dd/MM/yyyy HH:mm') : '',
          valorProposta: item.valor_proposta ? formatPrice(item.valor_proposta) : '',
          retornarEm: item.retorno_cliente ? format(new Date(item.retorno_cliente), 'dd/MM/yyyy HH:mm') : '',
          dataPropostaEncaminhada: item.data_proposta_encaminhada ? format(new Date(item.data_proposta_encaminhada), 'dd/MM/yyyy HH:mm') : '',
          info_proposta:
            item?.info_proposta &&
            item?.info_proposta?.map((item) => {
              return {
                ...item,
                codigo_produto: item.codigo_produto,
                cor: item.cor,
                quantidade_itens: new Intl.NumberFormat('pt-BR').format(item.quantidade_itens),
              }
            }),
          info_layout:
            item.info_layout &&
            item.info_layout.map((item) => {
              return {
                ...item,
                link_layout: item.link_layout,
                codigo_produto: item.codigo_produto,
                cor: item.cor,
                solicitacao: item.solicitacao
                  ? //dd/MM/yyyy às HH:mm
                    format(new Date(item.solicitacao), "dd/MM/yyyy '/' HH:mm")
                  : '',
                encaminhado: item.encaminhado ? format(new Date(item.encaminhado), "dd/MM/yyyy '/' HH:mm") : '',
                nome_usuario: item.nome_usuario ? item.nome_usuario : '',
              }
            }),
        }
      })
      //retira os duplicados, ex: tenho 2 AVEX BRASIL COMERCIAL, IMPORTADORA E EXPORTADORA LTDA.,
      ?.filter(
        (item, index, self) =>
          index ===
          self.findIndex(
            (t) => t.cliente === item.cliente && (t.info_contato ? t.info_contato.length : 0) >= (item.info_contato ? item.info_contato.length : 0)
          )
      )
  )
}

export function Filtro({ setData, setLoading }) {
  const [openModalCliente, setOpenModalCliente] = useState(false)
  const [valueModalCliente, setValueModalCliente] = useState({
    value: '',
    label: '',
  })
  const { handleSubmit, register } = useForm()
  const [isLargerThan1366] = useMediaQuery('(max-width: 1366px)')
  const { listaValorVerba } = useValorVerba()
  const { listaFunilVendas } = useFunilVendas()
  const { idVendedor } = useParams()

  const [selectedOption, setSelectedOption] = useState('')

  const [searchParams, setSearchParams] = useSearchParams()

  async function onSubmit(data) {
    const parameters = {
      clientes: clientesSelected.map((item) => item.codigo_cliente).join(','),
    }

    handleSearchParams(parameters)
  }

  const {
    data: dataCustomer,
    isLoading,
    mutateAsync,
  } = useMutation({
    mutationFn: ({ params, userCode: idVendedor }) =>
      getPropostasAcompanhamento({
        params: params,
        userCode: idVendedor,
      }),
    onSuccess: (data) => {
      setData(data)
      setLoading(false)
    },
  })

  const [funilDeVendas, setFunilDeVendas] = useState(
    searchParams
      .get('funil_vendas')
      ?.split(',')
      .map((item) => {
        return {
          value: parseInt(item),
          label: listaFunilVendas.find((funil) => funil.value === parseInt(item)),
        }
      }) || []
  )

  const [clientesSelected, setClientesSelected] = useState([])
  const conditionalRendering = {
    'Nome do cliente': 'NomeCliente',
    'CPF/CNPJ': 'CpfCnpj',
    'Código do Cliente': 'CodigoCliente',
    'E-mail': 'Email',
  }

  function handleFunilDeVendas(value) {
    setFunilDeVendas((old) => {
      if (old.includes(value)) {
        return old.filter((item) => item !== value)
      } else {
        return [...old, value]
      }
    })
  }

  useEffect(() => {
    if (searchParams.get('novos_chamados') === 'true') {
      setFunilDeVendas((prev) => {
        if (!prev.includes(0)) {
          return [...prev, 0]
        }

        return prev
      })
    }
  }, [searchParams])

  function handleInputValue(e, name) {
    const { value } = e.target

    setValueModalCliente({
      [name]: value,
    })
  }

  async function handleSelectedOptionValue() {
    setOpenModalCliente(true)
  }

  function handleSelectedFunilDeVendas() {
    //transforma array em string com virgula
    const concatenedValues = funilDeVendas.map((item) => item.value).join(',')

    handleSearchParams({ funil_vendas: concatenedValues })
  }

  function handleClientesSelected(value) {
    setClientesSelected(value)
    handleSearchParams({
      clientes: value.map((item) => item.codigo_cliente).join(','),
    })
    setOpenModalCliente(false)
  }

  useEffect(() => {
    setLoading(true)
    const params = Object.fromEntries(searchParams)
    //chama o mutate async com os parametros da url
    mutateAsync({ params: params, userCode: idVendedor })
  }, [searchParams, idVendedor])

  function handleSearchParams(params) {
    //guarda os parametros que ja estavam na url e adiciona os novos
    const newParams = new URLSearchParams(searchParams)

    setSearchParams({
      ...Object.fromEntries(newParams),
      ...params,
    })
  }

  return (
    <>
      <ModalCliente
        isOpen={openModalCliente}
        onClose={() => setOpenModalCliente(false)}
        value={valueModalCliente}
        handleClientesSelected={handleClientesSelected}
      />
      <Flex alignItems="center" justifyContent="space-between" w="100%" maxW="1339px" gap={2} mx="auto" as="form" onSubmit={handleSubmit(onSubmit)}>
        <InputInnovationSelect label={`${clientesSelected?.length} Selecionados` || 'Selecione'} maxW="571px" flex={1}>
          <Flex flexDir="column" gap={3} px={10} py={10} fontSize="15px">
            {!selectedOption && (
              <>
                <Text as="span" px={5}>
                  Iniciar uma nova busca de cliente
                </Text>
                {Object.keys(conditionalRendering).map((option) => (
                  <OptionButton key={option} option={option} onSelect={() => setSelectedOption(option)} />
                ))}
              </>
            )}

            {selectedOption && (
              <Flex flexDir="column" gap={5}>
                <Box bgColor="#378BBF" maxW="469px" w="100%" py={3} textAlign="center" color="white">
                  Consultar por{' '}
                  <Text textTransform="uppercase" as="span" fontSize="13px">
                    {selectedOption}
                  </Text>
                </Box>

                <Input
                  placeholder={`Digite o ${selectedOption}`}
                  maxW="469px"
                  w="100%"
                  py={3}
                  px={5}
                  border="1px solid #378BBF! important"
                  borderRadius="4px"
                  fontSize="15px"
                  fontWeight="semibold"
                  onChange={(e) => handleInputValue(e, conditionalRendering[selectedOption])}
                />

                <Flex alignItems="center" justifyContent="space-between">
                  <Button
                    maxW="181px"
                    w="full"
                    bgColor="transparent"
                    border="1px solid #378BBF"
                    color="#378BBF"
                    onClick={() => setSelectedOption('')}
                  >
                    Voltar
                  </Button>

                  <Button maxW="181px" w="full" ml="auto" onClick={handleSelectedOptionValue} disabled={isLoading}>
                    Buscar
                  </Button>
                </Flex>
              </Flex>
            )}
          </Flex>
        </InputInnovationSelect>
        <Switch
          icon={<Icon as={FaCheckCircle} color="#FFA200" fontSize="25px" />}
          label="Cliente especial"
          onChange={
            (e) =>
              handleSearchParams({
                ...searchParams,
                cliente_especial: e.target.checked,
              })
            // setParams({ ...params, cliente_especial: e.target.checked })
          }
          isDisabled={isLoading}
          defaultChecked={searchParams.get('cliente_especial') === 'true'}
        />

        <DropdownCheckbox
          maxW={isLargerThan1366 ? '220px' : '300px'}
          h="29px"
          label="Funil de Vendas:"
          setValue={handleFunilDeVendas}
          quantitySelected={funilDeVendas.length}
          options={listaFunilVendas}
          onConfirm={handleSelectedFunilDeVendas}
          defaultValue={searchParams
            .get('funil_vendas')
            ?.split(',')
            ?.map((item) => parseInt(item))}
          clearAll={() => {
            setFunilDeVendas([])
          }}
        />

        <DateComponent
          label="Retornar em"
          h="29px"
          onChange={(e) => handleSearchParams({ retornar_em: e.target.value })}
          defaultValue={searchParams.get('retornar_em')}
        />

        <Button type="submit" maxW="181px" w="100%" ml="10px" disabled={isLoading}>
          Buscar
        </Button>
      </Flex>
    </>
  )
}
